import { render, staticRenderFns } from "./logOutDialog.vue?vue&type=template&id=5b53aa8c&scoped=true"
import script from "./logOutDialog.vue?vue&type=script&lang=js"
export * from "./logOutDialog.vue?vue&type=script&lang=js"
import style0 from "./logOutDialog.vue?vue&type=style&index=0&id=5b53aa8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b53aa8c",
  null
  
)

export default component.exports